import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Close(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="currentColor"
                d="M594.1 500l376.4 376.4c26 26 26 68.1 0 94.1s-68.1 26-94.1 0L500 594.1 123.6 970.5c-26 26-68.1 26-94.1 0s-26-68.1 0-94.1L405.9 500 29.5 123.6c-26-26-26-68.1 0-94.1s68.1-26 94.1 0L500 405.9 876.4 29.5c26-26 68.1-26 94.1 0s26 68.1 0 94.1L594.1 500z"
            />
        </SvgIcon>
    );
}

Close.defaultProps = {
    viewBox: '0 0 1000 1000'
};

export default Close;
